module.exports = "<app-widgets-navbar entries=$ctrl.entries current-tab-form-valid=$ctrl.currentTabFormValid validate=true switch-tab-prefix=$ctrl.switchTabPrefix> </app-widgets-navbar> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/navbar/partial.html
// module id = 439
// module chunks = 0